<div class="box-details">
  <div class="box-dsc-row row">
    <div class="col-4" i18n>Rental</div>
    <div class="col-8">
      <span [matTooltip]="inquiry.rental?.name" matTooltipPosition="above">
        {{ inquiry.rental?.name }}
      </span>
    </div>
  </div>
  <div class="box-dsc-row row">
    <div class="col-4" i18n>Guests</div>
    <div class="col-8">
      {{ (inquiry.numAdults || 0) + (inquiry.numChild || 0) }}
    </div>
  </div>
  <div class="box-dsc-row row">
    <div class="col-4" i18n>Arrive</div>
    <div class="col-8">
      {{ inquiry.guestArrive | epochUTC : 'DD - MMM - YYYY' }}
    </div>
  </div>
  <div class="box-dsc-row row">
    <div class="col-4" i18n>Depart</div>
    <div class="col-8">
      {{ inquiry.guestDepart | epochUTC : 'DD - MMM - YYYY' }}
    </div>
  </div>
  <div class="box-dsc-row row">
    <div class="col-4" i18n>Days</div>
    <div class="col-8">
      {{ inquiry.guestDepart | dateDiff : inquiry.guestArrive }}<ng-container>&nbsp;</ng-container
      ><ng-container i18n>Days</ng-container>, {{ inquiry.guestDepart | dateDiff : inquiry.guestArrive : 'nights'
      }}<ng-container>&nbsp;</ng-container><ng-container i18n>Nights</ng-container>
    </div>
  </div>
</div>
